import { UserInfo } from "../../reducers/states/user-info";

export const NameOrEmailUtil = (userInfo: UserInfo) => {
  // Return first and last if it exists, otherwise default to email
  return userInfo.firstName && userInfo.lastName
    ? userInfo.firstName + " " + userInfo.lastName
    : userInfo.email;
}

const IsDevUser = (authEmail: string | undefined): boolean => {
  return !!authEmail && [
      "jeremy.cavner@consultant.wsdot.wa.gov",
      "listed@spinshot.net", // Jeremy's personal account        
      "dekofsn@wsdot.wa.gov",
      "ndeko12@gmail.com",   // dekofsn's personal account
    ].includes(authEmail, 0);
}

// todo: jcavner: create a reusable hook which can access authState and searchparams instead of passing them in
export const IsMockEnabled = (authEmail: string | undefined, searchParams: URLSearchParams) => {
  const domain = window.location.origin.split("//")[1]?.split(":")[0]?.toLowerCase();
  const mock = searchParams.get('mock');

  if (domain === "localhost" && mock !== "f") return true;
  
  const isEnabled = ["dev.vcc.systems", "stage.vcc.systems"].includes(domain) && mock === "t";
  return IsDevUser(authEmail) && isEnabled;
}